<template>
	<el-drawer :modal="false" :visible.sync="showSmsDrawer" class="sms-drawer" size="35%"
		title="Send SMS" @close="cleanSmsDrawer">
		<b-container>
			<b-form role="form" @submit.prevent="confirmSendSms">
				<b-row>
					<b-col md="12">
						<div>
							<h3>Select Template</h3>
							<el-select
								v-model="form.sms_template_id"
								filterable
								@change="setSmsContent"
								><el-option
								v-for="sms_template in customer_sms_template"
								:key="sms_template.sms_template_id"
								:label="sms_template.sms_title"
								:value="sms_template.sms_template_id"
								>
								</el-option>
							</el-select>
						</div>
						<div class="mt-2">
							<h3>SMS Title</h3>
							<el-input
								type="text"
								v-model="form.sms_title">
							</el-input>
						</div>
						<div class="mt-2">
							<h3>SMS Content</h3>
							<el-input
								type="textarea"
								:autosize="{ minRows: 2, maxRows: 4}"
								v-model="form.sms_content">
							</el-input>
						</div>
						<!-- History -->
						<div>
						</div>
					</b-col>
					<b-col md="8" sm="12" class="mx-auto text-center mt-4 pt-2">
						<b-button variant="primary" type="submit" class="w-100" :disabled="is_loading_btn">Send</b-button>
					</b-col>
				</b-row>
			</b-form>
			<div class="mt-4 eligiblity-table">
                <el-table
                    :data="tableData"
                    empty-text="No Data"
                    style="width: 100%" 
                    v-loading="is_loading_table"
                >
                    <el-table-column
                        prop="sms_content"
                        label="SMS Content"
                        min-width="130"
                    >
                        <template v-slot="{row}">
                            <span class="text-truncate">{{ row.sms_content }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column
                        prop="status"
                        label="Status"
                        min-width="110"
                        width="auto"
                    >
                        <template v-slot="{row}">
                            <span v-if="row.status">Success</span>
                            <span v-else class="text-red">Failed: {{ row.error_message }}</span>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
		</b-container>
	</el-drawer>
</template>
<script>
import { Table, TableColumn, Drawer, Option, Select, Tabs, TabPane } from 'element-ui'
import { mapActions, mapState } from 'pinia'
import { useMessagingStore } from '@/stores/messagingStore'
import { useAccessControlStore } from '@/stores/accessControlStore'
import { useAuthStore } from '@/stores/authStore'
import { useCustomerStore } from '@/stores/customerStore'
import {
    notifyFunctionMixin,
	swal
} from '@/assets/js/httpImports.js'
export default {
    mixins: [notifyFunctionMixin],
	components: {
		[Table.name]: Table,
        [TableColumn.name]: TableColumn,
		[Drawer.name]: Drawer,
		[Option.name]: Option,
		[Select.name]: Select,
		[Tabs.name]: Tabs,
		[TabPane.name]: TabPane,
	},
	data() {
		return {
			showSmsDrawer: false,
			is_loading_btn: false,
			is_loading_table: true,
			form: {
				sms_template_id: null,
				sms_title: '',
				sms_content: '',
			},
			tableData: [],
			customer_sms_template: [],
			// key:{
			//     messaging_documents: 1
			// },
		}
	},
	computed: {
		...mapState(useMessagingStore, ['sms_template_list']),
		...mapState(useAuthStore, ['auth_user']),
		...mapState(useCustomerStore, ['current_customer']),
		selectedSmsTemplate() {
			// Find and return the full sms_template object based on the selected ID
			return this.sms_template_list.find(
				template => template.sms_template_id === this.form.sms_template_id
			);
		}
	},
	async created() {
	},
	methods: {
		...mapActions(useMessagingStore, ['sendSms', 'getSmsLogs']),
		viewSmsDrawer(data) {
			this.showSmsDrawer = true;
			let sms_templates = JSON.parse(JSON.stringify(this.sms_template_list))
			if(this.showSmsDrawer) {
				this.customer_sms_template = sms_templates.filter(item => item.customer_status_id == this.current_customer.status.sub.status_id)
				this.getSmsLogContent()
			}
		},
		cleanSmsDrawer() {
			this.form = {
				sms_template_id: null,
				sms_title: '',
				sms_content: '',
			}
		},
		async getSmsLogContent() {
			let params = _gHlp.generateQueryParams({
				search: {
					owner_id: this.$route.params.customer_id,
					owner_type: 'Customer'
				}
			})
			this.tableData = await this.getSmsLogs(params);
			this.is_loading_table = false;
		},
		setSmsContent() {
			if (this.selectedSmsTemplate) {
				this.form.sms_title = this.selectedSmsTemplate.sms_title;
				this.form.sms_content = this.selectedSmsTemplate.sms_content;
			}
		},
		async confirmSendSms() {
			this.is_loading_btn = true;
			const postData = {
				owner_type: "Customer",
				owner_id: this.$route.params.customer_id,
				sms_number: this.current_customer.contact_no,
				sms_content: this.form.sms_content
			}
			swal.fire({
				title: "Attention",
				text: "Are you sure you want to send this?",
				icon: "info",
				confirmButtonText: 'Confirm',
				showCancelButton: true,
			}).then(async (result) => {
				if (result.isConfirmed) {
					const sendResult = await this.sendSms(postData);
					if(sendResult) {
						this.notifySuccess('<b>SMS: </b> - Successfully Sent.', 2000)
						let params = _gHlp.generateQueryParams({
							search: {
								owner_id: this.$route.params.customer_id,
								owner_type: 'Customer'
							}
						})
						this.tableData = await this.getSmsLogs(params);
					}
				}
			});
			this.is_loading_btn = false;
		},
	}
}
</script>